import { Colors } from 'library';

export const filterAccordionSx = {
    width: 260,
    backgroundColor: Colors.white,
    borderRadius: '12px !important',
    padding: '8px 16px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    '&:before': { display: 'none' },
};
